import * as Yup from 'yup'
import i18n from '../../i18n'
import { AUTH_KEYS, VALIDATION } from '../../utils/translation-constants'
import config from 'custom/config/environment'
import validationConfig from 'custom/config/validation.config.json'
const forgotPasswordConfig = validationConfig['forgotPassword']
const signUpConfig = validationConfig['signUp']
const forgotUsernameConfig = validationConfig['forgotUsername']

const validateForgotAccountNo = forgotPasswordConfig['isAccountNoRequired']
  ? {
      accountNumber: Yup.string()
        .required(i18n.t(VALIDATION.ACCOUNTNO))
        .matches(new RegExp(config.ACC_NO_VALIDATION), i18n.t(VALIDATION.REGACCOUNTNOVALID)),
    }
  : {
      accountNumber: Yup.string()
        .optional()
        .matches(new RegExp(config.ACC_NO_VALIDATION), i18n.t(VALIDATION.REGACCOUNTNOVALID)),
    }

const validateForgotUsername = forgotPasswordConfig['isUserNameRequired']
  ? {
      username: Yup.string()
        .matches(new RegExp('^[a-zA-Z0-9]{3,}$'), 'Alphanumeric Only')
        .min(4, i18n.t(VALIDATION.USERNAMEVALID))
        .max(40, i18n.t(VALIDATION.USERNAMEVALID))
        .required(i18n.t(VALIDATION.USERNAME)),
    }
  : {
      username: Yup.string()
        .optional()
        .matches(new RegExp('^[a-zA-Z0-9]{3,}$'), 'Alphanumeric Only')
        .min(4, i18n.t(VALIDATION.USERNAMEVALID))
        .max(40, i18n.t(VALIDATION.USERNAMEVALID)),
    }

const ValidateForgotDOB = forgotPasswordConfig['isDOBRequired']
  ? {
      dateOfBirth: Yup.date().required(i18n.t(VALIDATION.DOB)),
    }
  : {
      dateOfBirth: Yup.date().optional(),
    }

const ValidateForgotPhoneNo = forgotPasswordConfig['isPhoneNoRequired']
  ? {
      phoneNumber: Yup.string().required(i18n.t(VALIDATION.MOBILENO)),
    }
  : {
      phoneNumber: Yup.string().optional(),
    }

const ValidateSignUpAccountNo = signUpConfig['isAccountNoRequired']
  ? {
      accountNumber: Yup.string()
      .matches(new RegExp(config.ACC_NO_VALIDATION), i18n.t(VALIDATION.REGACCOUNTNOVALID))
      .required(i18n.t(VALIDATION.ACCOUNTNO)),
    }
  : {
      accountNumber: Yup.string().optional(),
    }

const ValidateSignUpPhoneNo = signUpConfig['isPhoneNoRequired']
  ? {
      phoneNumber: Yup.string().required(i18n.t(VALIDATION.MOBILENO)),
    }
  : {
      phoneNumber: Yup.string().optional(),
    }

const ValidateSignUpDOB = signUpConfig['isDOBRequired']
  ? {
      dateOfBirth: Yup.string().required(i18n.t(VALIDATION.DOB)),
    }
  : {
      dateOfBirth: Yup.string().optional(),
    }

const ValidateSignUpIdentity = signUpConfig['isUniqueIdRequired']
  ? {
    uniqueIdType: Yup.string().required(i18n.t(VALIDATION.IDENTITY_TYPE)),
  }
  : {
    uniqueIdType: Yup.string().optional(),
  }

const ValidateSignUpIdentityValue = signUpConfig['isUniqueIdRequired']
  ? {
    uniqueIdValue: Yup.string().required(i18n.t(VALIDATION.IDENTITY_NO)),
  }
  : {
    uniqueIdValue: Yup.string().optional(),
  }


    
const ValidateForgotUserAccountNo = forgotUsernameConfig['isAccountNoRequired']
? {
  srcAccount: Yup.string().required(i18n.t(VALIDATION.ACCOUNTNO)),
  }
: {
  srcAccount: Yup.string().optional(),
  }

const ValidateForgotUserPhoneNo = forgotUsernameConfig['isPhoneNoRequired']
? {
  mobileNo: Yup.string().required(i18n.t(VALIDATION.MOBILENO)),
  }
: {
  mobileNo: Yup.string().optional(),
  }

const ValidateForgotUserDOB = forgotUsernameConfig['isDOBRequired']
? {
  customerDob: Yup.string().required(i18n.t(VALIDATION.DOB)),
  }
: {
  customerDob: Yup.string().optional(),
  }

const ValidateForgotUserIdentity = forgotUsernameConfig['isUniqueIdRequired']
  ? {
    uniqueIdType: Yup.string().required(i18n.t(VALIDATION.IDENTITY_TYPE)),
  }
  : {
    uniqueIdType: Yup.string().optional(),
  }

const ValidateForgotUserIdentityValue = signUpConfig['isUniqueIdRequired']
  ? {
    uniqueIdValue: Yup.string().required(i18n.t(VALIDATION.IDENTITY_NO)),
  }
  : {
    uniqueIdValue: Yup.string().optional(),
  }

export const LoginSchema = Yup.object().shape({
  username: Yup.string()
  .min(4, i18n.t(VALIDATION.USERNAMEVALID))
  .max(40, i18n.t(VALIDATION.USERNAMEVALID))
  .required(i18n.t(VALIDATION.USERNAME)),
  password: Yup.string().required(i18n.t(VALIDATION.PASSWORD)),
})

export const ForgotPasswordSchema = Yup.object().shape({
  ...validateForgotAccountNo,
  ...validateForgotUsername,
  ...ValidateForgotDOB,
  ...ValidateForgotPhoneNo,
})

export const ForgotPasswordConfirmSchema = Yup.object().shape({
  newPassword: Yup.string()
    .required(i18n.t(VALIDATION.NEWPASSWORD))
    .min(8, i18n.t(VALIDATION.PASSWORDVALID))
    .max(14, i18n.t(VALIDATION.PASSWORDVALID)),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], i18n.t(VALIDATION.PASSWORDNOTMATCH))
    .required(i18n.t(VALIDATION.CONFIRMNEWPASSWORD)),
  otp: Yup.string()
    .matches(new RegExp('^[0-9]{4}$'), 'Invalid OTP')
    .required(i18n.t(VALIDATION.OTP)),
})

export const ForgotUserNameSchema = Yup.object().shape({
 ...ValidateForgotUserAccountNo,
 ...ValidateForgotUserPhoneNo,
 ...ValidateForgotUserDOB,
 ...ValidateForgotUserIdentity,
 ...ValidateForgotUserIdentityValue,
  // passport: Yup.string().when('identityType', {
  //   is: 'Passport No.',
  //   then: Yup.string().required(i18n.t(VALIDATION.PASSPORTNO)),
  //   otherwise: Yup.string().optional(),
  // }),
  // nationalId: Yup.string().when('identityType', {
  //   is: 'National ID',
  //   then: Yup.string().required(i18n.t(VALIDATION.NRCNO)),
  //   otherwise: Yup.string().optional(),
  // }),
})

export const SignUpSchema = Yup.object().shape({
  ...ValidateSignUpDOB,
  ...ValidateSignUpIdentity,
  ...ValidateSignUpAccountNo,
  ...ValidateSignUpPhoneNo,
  ...ValidateSignUpIdentityValue,
  // passportNumber: Yup.string().when('identityType', {
  //   is: 'Passport No.',
  //   then: Yup.string().required(i18n.t(VALIDATION.PASSPORTNO)),
  //   otherwise: Yup.string().optional(),
  // }),
  // nrcNumber: Yup.string().when('identityType', {
  //   is: 'National ID',
  //   then: Yup.string().required(i18n.t(VALIDATION.NRCNO)),
  //   otherwise: Yup.string().optional(),
  // }),
})

export const SignUpSchemaConfirm = Yup.object().shape({
  userName: Yup.string()
    .required(i18n.t(VALIDATION.USERNAME))
    .min(4, i18n.t(VALIDATION.USERNAMEVALID)),
  password: Yup.string()
    .required(i18n.t(VALIDATION.PASSWORD))
    .min(8, i18n.t(VALIDATION.PASSWORDVALID))
    .max(14, i18n.t(VALIDATION.PASSWORDVALID)),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], i18n.t(VALIDATION.PASSWORDNOTMATCH))
    .required(i18n.t(VALIDATION.CONFIRMNEWPASSWORD)),
})

export const NewCustomerDetailsForm0Schema = Yup.object().shape({
  accountType: Yup.string().required(i18n.t(VALIDATION.REQUIRED)),
  accountCurrency: Yup.string().required(i18n.t(VALIDATION.REQUIRED)),
})

export const NewCustomerDetailsForm3Schema = Yup.object().shape({
  identityType: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_IDENTITY_TYPE)),
  identityNumber: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_IDENTITY_NUMBER)),
  issueDate: Yup.string().when('identityType', {
    is: 'Passport',
    then: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_ISSUE_DATE)),
    otherwise: Yup.string(),
  }),
  expiryDate: Yup.string().when('identityType', {
    is: 'Passport',
    then: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_EXPIRY_DATE)),
    otherwise: Yup.string(),
  }),
  countryOfIssuance: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_COUNTRY_OF_ISSUE)),
})

export const NewCustomerDetailsForm1Schema = Yup.object().shape({
  customerInfo: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_TITLE_FIELD)),
  // Tpin: Yup.string()
  //   .min(10)
  //   .max(12)
  //   .matches(new RegExp('^[a-zA-Z0-9]+$'), 'Alphanumeric only')
  //   .required('Required'),
  firstName: Yup.string().matches(new RegExp('^[a-zA-Z]+$'), i18n.t(VALIDATION.ALPHABETS_ONLY)),
  // .required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_FIRST_NAME)),
  lastName: Yup.string().matches(new RegExp('^[a-zA-Z]+$'), i18n.t(VALIDATION.ALPHABETS_ONLY)).required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_LAST_NAME)),
  middleName: Yup.string().matches(new RegExp('^[a-zA-Z]+$'), i18n.t(VALIDATION.ALPHABETS_ONLY)),
  maritalStatus: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_MARITAL_STATUS)),
  dateOfBirth: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_DATE_OF_BIRTH)),
  placeOfBirth: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_PLACE_OF_BIRTH)),
  nationality: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_NATIONALITY)),
  // identityType: Yup.string().required('Required'),
  // issueDate: Yup.string(),
  // expiryDate: Yup.string(),
})

export const NewCustomerDetailsForm2Schema = Yup.object().shape({
  phoneNumber: Yup.string().when('countryCode', {
    is: 'CM',
    then: Yup.string()
    // .min(9)
    .matches(new RegExp('^[0-9]{9}$'), i18n.t(VALIDATION.MOBILE_NUMBER_LENGTH))
    .required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_PHONE_NUMBER)),
    otherwise: Yup.string() 
    // .min(9)
    // .max(10)
    .matches(new RegExp('^[0-9]{9,10}$'),  i18n.t(VALIDATION.MIN_MAX_MOBILE_NUMBER_LENGTH))
    .required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_PHONE_NUMBER)),
  }),
  emailId: Yup.string().email(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_INVALID_EMAIL_ID))
  .required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_EMAIL_ID)),
  houseNum: Yup.string(),
    // .required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_HOUSE_NUMBER)),
  street: Yup.string(),
  // .required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_STREET_LOCALITY_AREA)),
  city: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_REGION)),
  employmentType: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_EMPLOYMENT_TYPE)),
  sourceOfIncome: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_SOURCE_OF_INCOME)),
  incomeRange: Yup.string().required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_INCOME_RANGE)),
  countryCode: Yup.string()
    .required(i18n.t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.VALIDATION_COUNTRY_CODE)),
})